import i18n from 'modules/core/lib/i18n'

import { ProductUpdatesVisibilityConfig } from './types'

export const getProductUpdatesVisibility: ProductUpdatesVisibilityConfig = (navigation) => ({
  ats: {
    routes: [navigation.ats.fullPath()],
    moduleName: 'ats',
    productName: i18n.t('sidebar.recruitment'),
  },
  documents: {
    routes: [navigation.documents.fullPath(), navigation.files.fullPath()],
    moduleName: 'documents',
    productName: i18n.t('sidebar.documents'),
  },
  analytics: {
    routes: [navigation.analytics.fullPath()],
    moduleName: 'analytics',
    productName: i18n.t('sidebar.analytics'),
  },
  time_tracking: {
    routes: [navigation.timeTracking.fullPath()],
    moduleName: 'time_tracking',
    productName: i18n.t('sidebar.time_tracking'),
  },
  timeoff: {
    routes: [navigation.timeOff.fullPath()],
    moduleName: 'time-off',
    productName: i18n.t('sidebar.time_off'),
  },
  shift_management: {
    routes: [navigation.shifts.fullPath()],
    moduleName: 'shift_management',
    productName: i18n.t('sidebar.shift_management'),
  },
  payroll: {
    routes: [navigation.payrollBundle.fullPath(), navigation.myPayroll.fullPath()],
    moduleName: 'payroll',
    productName: i18n.t('sidebar.payroll_bundle'),
  },
  projects: {
    routes: [navigation.projects.fullPath(), navigation.myProjects.fullPath()],
    moduleName: 'projects',
    productName: i18n.t('sidebar.projects_management'),
  },
  expenses: {
    routes: [navigation.expenses.fullPath(), navigation.myExpenses.fullPath()],
    moduleName: 'expenses',
    productName: i18n.t('sidebar.expenses_v2'),
  },
  trainings: {
    routes: [navigation.trainings.fullPath(), navigation.myTrainings.fullPath()],
    moduleName: 'trainings',
    productName: i18n.t('sidebar.trainings'),
  },
  reviews: {
    routes: [navigation.performanceProcess.fullPath()],
    moduleName: 'performance',
    productName: i18n.t('sidebar.performance_new'),
  },
  software_management: {
    routes: [navigation.software.fullPath()],
    moduleName: 'software_management',
    productName: i18n.t('sidebar.software_management'),
  },
  factorial_core: {
    routes: [
      navigation.dashboard.fullPath(),
      navigation.inbox.fullPath(),
      navigation.discover.productUpdates.fullPath(),
    ],
    moduleName: 'factorial-core',
    productName: 'Factorial',
  },
})
